import { useState } from 'react'
import Typography from '@mui/material/Typography';

import Grid from '@mui/material/Grid';
import { SignalItem } from "../../interface/SignalItem";
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../interface/ApplicationState';
import { SignalDetails } from './SignalDetailsModal';
import { SignalCard } from './SignalCard';
import { Box, Chip, useTheme } from '@mui/material';
import { SearchBar } from '../../components/SearchBar';
import QueryStats from '@mui/icons-material/QueryStats';
import { alpha } from '@mui/material/styles';
import { dashboardMutedTextSx, getDashboardPanelSx } from '../dashboardv2/dashboardStyles';
interface SignalsListProps
{
  signals: SignalItem[] | undefined
}

export const SignalsList = ({ signals }: SignalsListProps) =>
{
  const [ showSignalDetailsModal, setShowSignalDetailsModal ] = useState<SignalItem | undefined>()
  const user = useSelector((state: ApplicationState) => state.userStore.user)
  const theme = useTheme()
  const [ query, setQuery ] = useState("")


  const isSourceEnabled = (source: string) =>
  {
    if(user && user.signalsInvestSources && user.signalsInvestSources.length > 0 && user.signalsInvestSources.includes(source)) return true
    return false
  }

  const filterSignals = () =>
  {
    if(query && query.length > 2 && signals)
    {
      return signals.filter(signal => {
        if(signal.pair.toLowerCase().includes(query.toLowerCase())) return true
        if(signal.source.toLowerCase().includes(query.toLowerCase())) return true

      })
    }

    return signals || []
  }


  return(
    <Box sx={{ ...getDashboardPanelSx(theme), p: { xs: 2, md: 2.5 } }}> 
    <Typography variant="overline" sx={{ letterSpacing: 1.5, ...dashboardMutedTextSx(theme) }}>Signals Listings</Typography>
    <Typography sx={{ fontSize: 28, lineHeight: 1.15, mb: 1.5 }}>Scan the latest signals</Typography>

    <Box sx={{ mb: 2, display: "flex", gap: 1, flexWrap: "wrap" }}>
      <Chip label={`${signals?.length || 0} listings`} sx={styles.filterChip(theme)} />
      <Chip label={`${filterSignals().length} shown`} sx={styles.filterChip(theme)} />
      <Chip label={query ? `Query: ${query}` : "Search by pair or source"} sx={styles.filterChip(theme)} />
    </Box>

    <Box sx={{ mb: 3 }}>
      <SearchBar placeholder="Search Signals Listings" setQuery={setQuery} />
    </Box>    


      <Grid container spacing={2}>

      {
        filterSignals().length > 0
         ?
         filterSignals().map((signal, key) => <SignalCard key={key} signal={signal} isEnabled={isSourceEnabled(signal.source)} onClickSignal={(signal) => setShowSignalDetailsModal(signal)}/>) 
         : <Box sx={styles.noSigals(theme)}>
           <QueryStats sx={styles.icon} htmlColor="grey" />
           <Typography fontWeight="700" variant="subtitle1" color="textSecondary" >Looks like we could not find any signals</Typography>
         </Box>
      }
       </Grid>

       { showSignalDetailsModal && <SignalDetails signal={showSignalDetailsModal} open={!!showSignalDetailsModal} handleClose={() => setShowSignalDetailsModal(undefined)} /> }

      </Box>
  )
}


const styles = {
  icon: {
    width: 100,
    height: 100
  },

  noSigals: (theme: any) => ({
    paddingTop: 16,
    paddingBottom: 16,
    height: "20vh",
    display: "flex",
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: "column",
    borderRadius: "12px",
    border: `1px dashed ${alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.12 : 0.45)}`,
    backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.03 : 0.45),
  }),
  filterChip: (theme: any) => ({
    borderRadius: "999px",
    backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.68),
    color: theme.palette.text.primary,
  }),
}
